import { render } from "./Ship.vue?vue&type=template&id=7bc95fa9&scoped=true"
import script from "./Ship.vue?vue&type=script&lang=js"
export * from "./Ship.vue?vue&type=script&lang=js"

import "./Ship.vue?vue&type=style&index=0&id=7bc95fa9&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc95fa9"]])

export default __exports__